<template>
  <div class="editor">
    <b-navbar vertical class="navbar-vertical fixed-left" toggleable="lg">
      <b-container fluid>
        <b-button
          variant="outline-secondary"
          @click="showNavi = !showNavi"
          class="d-md-none d-lg-none d-xl-none"
        >
          <font-awesome-icon :icon="['fal', 'sliders-h']" size="lg" />
        </b-button>
        <logo></logo>
        <b-btn
          class="export-btn d-md-none d-lg-none d-xl-none"
          @click="exportToImage"
          variant="primary"
        >
          <template v-if="!isConverting">
            <font-awesome-icon :icon="['fal', 'download']" />
          </template>
          <template v-else>
            Converting...
          </template>
        </b-btn>

        <div class="dropdown-divider d-none d-md-block"></div>

        <b-collapse
          is-nav
          id="nav_collapse"
          :style="{ display: showNavi ? 'block' : 'none' }"
        >
          <b-navbar-nav>
            <li class="nav-item">
              <a
                class="nav-link"
                v-b-toggle.background
                data-toggle="collapse"
                href="javascript:void(0)"
              >
                <font-awesome-icon
                  :icon="['fal', 'vector-square']"
                  size="lg"
                  fixed-width
                />Canvas
              </a>
              <b-collapse id="background" class="mt-2 py-3 px-4 ">
                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Width</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="canvasWidth"
                    ></b-input>
                  </b-col>
                </b-row>

                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Height</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="canvasHeight"
                    ></b-input>
                  </b-col>
                </b-row>

                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Padding</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="canvasPadding"
                    ></b-input>
                  </b-col>
                </b-row>
                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Background Color</label>
                  </b-col>
                  <b-col>
                    <input-color-picker v-model="canvasBgColor"></input-color-picker>
                  </b-col>
                </b-row>
              </b-collapse>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                v-b-toggle.window
                data-toggle="collapse"
                href="javascript:void(0)"
              >
                <font-awesome-icon
                  :icon="['fal', 'window']"
                  size="lg"
                  fixed-width
                />Window
              </a>
              <b-collapse id="window" class="mt-2 py-3 px-4 ">
                <b-row align-v="center" class="mb-2">
                  <b-col sm="4">
                    <label>Style</label>
                  </b-col>
                  <b-col>
                    <multiselect
                      v-model="windowActionStyle"
                      :multiple="false"
                      :options="actionStyles"
                      :allow-empty="false"
                      :show-labels="false"
                    ></multiselect>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label>Buttons</label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchWindowButtons"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="windowShowWindowButtons"
                      />
                      <label
                        class="custom-control-label"
                        for="switchWindowButtons"
                      ></label>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label>Title</label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchWindowTitle"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="windowShowWindowTitle"
                      />
                      <label
                        class="custom-control-label"
                        for="switchWindowTitle"
                      ></label>
                    </div>
                  </b-col>
                </b-row>
                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Width</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="windowWidth"
                      max="500"
                    ></b-input>
                  </b-col>
                </b-row>
                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Height</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="windowHeight"
                      min="90"
                    ></b-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label>Border radius</label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchWindowBorderRadius"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="windowShowBorderRadius"
                      />
                      <label
                        class="custom-control-label"
                        for="switchWindowBorderRadius"
                      ></label>
                    </div>
                  </b-col>
                </b-row>
                <div v-show="windowShowBorderRadius">
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Top left</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        v-model="windowBorderRadiusTopLeft"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Top right</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        v-model="windowBorderRadiusTopRight"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Bottom right</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        v-model="windowBorderRadiusBottomRight"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Bottom left</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        v-model="windowBorderRadiusBottomLeft"
                      ></b-input>
                    </b-col>
                  </b-row>
                </div>

                <b-row>
                  <b-col>
                    <label>Shadow</label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchWindowShadow"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="windowShowShadow"
                      />
                      <label
                        class="custom-control-label"
                        for="switchWindowShadow"
                      ></label>
                    </div>
                  </b-col>
                </b-row>
                <div v-show="windowShowShadow">
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Offset X</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        placeholder="auto"
                        v-model="windowShadowOffsetX"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Offset Y</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        placeholder="auto"
                        v-model="windowShadowOffsetY"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Blur radius</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        placeholder="auto"
                        v-model="windowShadowBlurRadius"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Spread radius</label>
                    </b-col>
                    <b-col>
                      <b-input
                        type="number"
                        size="sm"
                        placeholder="auto"
                        v-model="windowShadowSpreadRadius"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-row align-v="center" class="mb-2 pl-3">
                    <b-col>
                      <label>Color</label>
                    </b-col>
                    <b-col>
                      <input-color-picker
                        v-model="windowShadowColor"
                      ></input-color-picker>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                v-b-toggle.code
                data-toggle="collapse"
                href="javascript:void(0)"
              >
                <font-awesome-icon
                  :icon="['fal', 'code']"
                  size="lg"
                  fixed-width
                />Editor
              </a>
              <b-collapse id="code" class="mt-2 py-3 px-4 ">
                <b-row align-v="center" class="mb-2">
                  <b-col sm="4">
                    <label>Theme</label>
                  </b-col>
                  <b-col>
                    <multiselect
                      v-model="editorThemeSelected"
                      :multiple="false"
                      :options="themes"
                      placeholder="Default"
                      label="name"
                      track-by="name"
                      :show-labels="false"
                      :option-height="104"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc">
                          <span class="option__title">{{
                            props.option.name
                          }}</span>
                        </span>
                      </template>
                      <template slot="option" slot-scope="props">
                        <img
                          class="option__image"
                          :src="'/themes/' + props.option.name + '.png'"
                          style="width:100%;"
                        />
                        <p style="margin: 0;text-align: center;margin-top: .5rem;">{{ props.option.name }}</p>
                      </template>
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row align-v="center" class="mb-2">
                  <b-col sm="4">
                    <label>Language</label>
                  </b-col>
                  <b-col>
                    <multiselect
                      v-model="editorModeSelected"
                      :multiple="false"
                      :options="modes"
                      placeholder="Auto"
                      label="name"
                      track-by="name"
                      :show-labels="false"
                    ></multiselect>
                  </b-col>
                </b-row>

                <b-row align-v="center" class="mb-2">
                  <b-col>
                    <label>Font size</label>
                  </b-col>
                  <b-col>
                    <b-input
                      type="number"
                      size="sm"
                      placeholder="auto"
                      v-model="editorFontSize"
                    ></b-input>
                  </b-col>
                </b-row>

                <b-row class="mb-3">
                  <b-col>
                    <label>Line numbers</label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchLines"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="editorShowLinesNumbers"
                      />
                      <label
                        class="custom-control-label"
                        for="switchLines"
                      ></label>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="d-none">
                  <b-col>
                    <label>
                      Preview<br />
                      <small class="text-muted">Only for HTML</small>
                    </label>
                  </b-col>
                  <b-col class="text-right">
                    <div class="custom-control custom-switch">
                      <input
                        class="custom-control-input"
                        id="switchPreview"
                        type="checkbox"
                        tabindex="5"
                        required
                        v-model="editorShowHTMLPreview"
                      />
                      <label
                        class="custom-control-label"
                        for="switchPreview"
                      ></label>
                    </div>
                  </b-col>
                </b-row>
              </b-collapse>
            </li>
          </b-navbar-nav>
          <b-button
            block
            variant="outline-danger"
            size="sm"
            class="mt-3"
            @click="initSettings"
          >
            Reset settings
          </b-button>
          <div class="mt-auto"></div>
          <div class="dropdown-divider"></div>
          <b-navbar-nav>
            <b-nav-text class="text-center">
              <a href="https://www.instagram.com/codeimg/" target="_blank" @click="socialMediaEvent('instagram')">
                <font-awesome-icon :icon="['fab', 'instagram']" fixed-width size="2x"/>
              </a>
              <a href="https://twitter.com/codeimg" target="_blank" @click="socialMediaEvent('twitter')">
                <font-awesome-icon :icon="['fab', 'twitter']" fixed-width size="2x"/>
              </a>
              <a href="https://www.facebook.com/codeimg" target="_blank" @click="socialMediaEvent('facebook')">
                <font-awesome-icon :icon="['fab', 'facebook']" fixed-width size="2x"/>
              </a>
            </b-nav-text>
            <b-nav-text class="text-center">
              <a
                href="https://github.com/Crodev/codeimg_feedback/issues"
                target="_blank"
                >Feedback</a
              >
              |
              <a
                      href="https://github.com/Crodev/codeimg_feedback/issues"
                      target="_blank"
              >Bug report</a>
              |
              <router-link to="board">ToDo</router-link>
            </b-nav-text>
            <b-nav-text class="text-center">
              <small>version: 1.0.1</small>
            </b-nav-text>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <div class="main-content" @click="showNavi = false">
      <header class="header">
        <div class="header-body">
          <b-row align-v="center">
            <b-col class="d-none d-lg-block">
              <b-btn variant="success" @click="showNewProjectDialog">
                <font-awesome-icon :icon="['fal', 'file-plus']" fixed-width />
                New project
              </b-btn>
            </b-col>
            <b-col sm="12" lg="8" class="text-center">
              <h2
                v-b-modal.ProjectNameDialog
                class="header-title text-secondary"
                style="cursor:pointer;"
              >
                {{ projectName }}.{{ fileTypeSelected }}
              </h2>
            </b-col>
            <b-col class="d-none d-lg-block">
              <b-btn
                block
                class="export-btn"
                @click="exportToImage"
                variant="primary"
              >
                <template v-if="!isConverting">
                  <font-awesome-icon :icon="['fal', 'download']" fixed-width />
                  Download
                </template>
                <template v-else>
                  Converting...
                </template>
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </header>

      <b-row no-gutters class="canvas-wrapper" align-v="start" align-h="center">
        <b-col sm="auto">
          <div class="editor-canvas">
            <div
              class="editor-wrapper"
              ref="editorExport"
              v-bind:style="canvasOptions"
            >
              <div class="editor-window" v-bind:style="windowOptions">
                <b-row
                  :class="[
                    'editor-window-titlebar',
                    windowActionStyle + '-mode'
                  ]"
                  v-show="windowShowWindowButtons || windowShowWindowTitle"
                >
                  <b-col sm="auto" v-show="windowShowWindowButtons">
                    <div class="editor-window--actions">
                      <span class="editor-window--action exit"></span>
                      <span class="editor-window--action minimize"></span>
                      <span class="editor-window--action maximize"></span>
                    </div>
                  </b-col>
                  <b-col v-show="windowShowWindowTitle">
                    <div class="editor-window--title">
                      <input
                        type="text"
                        value="Title"
                        class="editor-window--title-input"
                        v-bind:style="{ color: editorThemeSelectedColor }"
                      />
                    </div>
                  </b-col>
                </b-row>
                <div class="editor-content">
                  <b-row no-gutters>
                    <b-col>
                      <codemirror
                        v-model="code"
                        :options="editorOptions"
                        :style="{ fontSize: editorFontSize + 'px' }"
                      ></codemirror>
                    </b-col>
                    <b-col v-show="editorShowHTMLPreview">
                      <iframe ref="htmlPreview"></iframe>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <NewProjectDialog
      ref="newProjectDialog"
      v-on:createdProject="UserCreatedNewProject"
    ></NewProjectDialog>
    <ProjectNameDialog :name="projectName" @update="UpdateName" />
  </div>
</template>

<script>
import logo from "@/components/logo.vue";
import { LANGUAGES, LANGUAGES_FORMATTED, THEMES } from "@/constants.js";
import Multiselect from "vue-multiselect";
import * as hljs from "highlight.js";
import "file-saver";
import { mapFields } from "vuex-map-fields";

// require component
import { codemirror } from "vue-codemirror";
import domtoimage from "dom-to-image";
import InputColorPicker from "../components/inputs/InputColorPicker";
import NewProjectDialog from "../components/dialogs/NewProjectDialog";
import ProjectNameDialog from "../components/dialogs/ProjectNameDialog";

// require styles
import "@/themes";
import "@/modes";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "editor",
  data() {
    return {
      showNavi: false,
      isConverting: false,
      isFirstStar: true,
      actionStyles: ["MacOS", "Windows"],
      editName: false,
      modes: LANGUAGES,
      themes: THEMES,
      projectName: "Untitled",
      fileTypes: ["jpeg", "png", "svg"],
      fileTypeSelected: "jpeg",
      code: "// Code here",
      generatedImageSrc: {
        jpeg: "",
        png: "",
        svg: ""
      }
    };
  },
  components: {
    codemirror,
    logo,
    Multiselect,
    InputColorPicker,
    NewProjectDialog,
    ProjectNameDialog
  },
  methods: {
    setMode(mode) {
      this.modeSelected = mode;
    },
    async exportToImage() {
      this.isConverting = true;
      const canvas = this.$refs.editorExport,
        _this = this;

      switch (this.fileTypeSelected) {
        case "png":
          await domtoimage.toPng(canvas).then(function(dataUrl) {
            _this.generatedImageSrc.png = dataUrl;
          });
          break;
        case "svg":
          await domtoimage.toSvg(canvas).then(function(dataUrl) {
            _this.generatedImageSrc.svg = dataUrl;
          });
          break;
        case "jpeg":
        default:
          await domtoimage.toJpeg(canvas).then(function(dataUrl) {
            _this.generatedImageSrc.jpeg = dataUrl;
          });
          break;
      }

      this.isConverting = false;

      window.saveAs(
        this.generatedImageSrc[this.fileTypeSelected],
        this.projectName + "." + this.fileTypeSelected
      );

      this.$ga.event({
        eventAction: "download"
      });
    },
    socialMediaEvent(network) {
      this.$ga.event({
        eventCategory: "social_media",
        eventAction: "link",
        eventLabel: network
      });
    },
    showNewProjectDialog() {
      this.$refs.newProjectDialog.openDialog();
    },
    UserCreatedNewProject(options) {
      this.canvasWidth = options.canvasWidth;
      this.canvasHeight = options.canvasHeight;
      this.windowWidth = options.canvasWidth - this.canvasPadding * 2;
      this.windowHeight = options.canvasHeight - this.canvasPadding * 2;
      this.projectName = options.projectName ? options.projectName : "Untitled";
      this.fileTypeSelected = options.projectFileType;
    },
    UpdateName(options) {
      this.projectName = options.projectName;
      this.fileTypeSelected = options.projectFileType;
    },
    initSettings() {
      this.canvasWidth = "";
      this.canvasHeight = "";
      this.canvasPadding = 50;
      this.canvasBgColor = "#FFFFFF";
      this.windowActionStyle = "MacOS";
      this.windowShowWindowButtons = true;
      this.windowShowWindowTitle = true;
      this.windowWidth = "";
      this.windowHeight = "";
      this.windowShowBorderRadius = true;
      this.windowBorderRadiusTopLeft = "5";
      this.windowBorderRadiusTopRight = "5";
      this.windowBorderRadiusBottomRight = "5";
      this.windowBorderRadiusBottomLeft = "5";
      this.windowShowShadow = true;
      this.windowShadowOffsetX = "0";
      this.windowShadowOffsetY = "20";
      this.windowShadowBlurRadius = "68";
      this.windowShadowSpreadRadius = "0";
      this.windowShadowColor = "rgba(0, 0, 0, 0.55)";
      this.editorModeSelected = "";
      this.editorShowLinesNumbers = true;
      this.editorShowHTMLPreview = false;
      this.editorThemeSelectedName = "seti";
      this.editorThemeSelectedBackground = "#151718";
      this.editorThemeSelectedColor = "#CFD2D1";
      this.editorFontSize = 16;
    }
  },
  computed: {
    ...mapFields({
      canvasWidth: "canvas.width",
      canvasHeight: "canvas.height",
      canvasPadding: "canvas.padding",
      canvasBgColor: "canvas.backgroundColor",
      windowActionStyle: "window.actionStyle",
      windowShowWindowButtons: "window.showWindowButtons",
      windowShowWindowTitle: "window.showWindowTitle",
      windowWidth: "window.width",
      windowHeight: "window.height",
      windowShowBorderRadius: "window.showBorderRadius",
      windowBorderRadiusTopLeft: "window.borderRadiusTopLeft",
      windowBorderRadiusTopRight: "window.borderRadiusTopRight",
      windowBorderRadiusBottomRight: "window.borderRadiusBottomRight",
      windowBorderRadiusBottomLeft: "window.borderRadiusBottomLeft",
      windowShowShadow: "window.showShadow",
      windowShadowOffsetX: "window.shadow.offsetX",
      windowShadowOffsetY: "window.shadow.offsetY",
      windowShadowBlurRadius: "window.shadow.blurRadius",
      windowShadowSpreadRadius: "window.shadow.spreadRadius",
      windowShadowColor: "window.shadow.color",
      editorModeSelected: "editor.modeSelected",
      editorShowLinesNumbers: "editor.showLinesNumbers",
      editorShowHTMLPreview: "editor.showHTMLPreview",
      editorThemeSelected: "editor.themeSelected",
      editorThemeSelectedName: "editor.themeSelected.name",
      editorThemeSelectedBackground: "editor.themeSelected.background",
      editorThemeSelectedColor: "editor.themeSelected.color",
      editorFontSize: "editor.font.size"
    }),
    detectTheme() {
      return this.editorThemeSelected ? this.editorThemeSelectedName : "";
    },
    detectMode() {
      if (this.editorModeSelected.mime === "auto" || !this.editorModeSelected) {
        const detectedLanguage = hljs.highlightAuto(this.code).language;
        return LANGUAGES_FORMATTED[detectedLanguage]
          ? LANGUAGES_FORMATTED[detectedLanguage].mime
          : "javascript";
      } else {
        return this.editorModeSelected.mime;
      }
    },
    editorOptions() {
      return {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: this.editorShowLinesNumbers,
        line: this.editorShowLinesNumbers,
        lineWrapping: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: this.detectMode,
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: this.detectTheme
      };
    },
    windowOptions() {
      let height = this.windowHeight;

      height = height < 90 ? 90 : height;

      let options = {
        backgroundColor: this.editorThemeSelectedBackground,
        minHeight: height ? height + "px" : "auto",
        minWidth: this.windowWidth ? this.windowWidth + "px" : "auto"
      };

      if (this.windowShowBorderRadius) {
        Object.assign(options, {
          borderTopLeftRadius: this.windowBorderRadiusTopLeft + "px",
          borderTopRightRadius: this.windowBorderRadiusTopRight + "px",
          borderBottomRightRadius: this.windowBorderRadiusBottomRight + "px",
          borderBottomLeftRadius: this.windowBorderRadiusBottomLeft + "px"
        });
      }

      if (this.windowShowShadow) {
        let shadow =
          this.windowShadowOffsetX +
          "px " +
          this.windowShadowOffsetY +
          "px " +
          this.windowShadowBlurRadius +
          "px " +
          this.windowShadowSpreadRadius +
          "px " +
          this.windowShadowColor;

        Object.assign(options, {
          boxShadow: shadow
        });
      }

      return options;
    },
    canvasOptions() {
      let height = this.canvasHeight;
      let width = this.canvasWidth;

      height = height < this.windowHeight ? this.windowHeight : height;
      width = width < this.windowWidth ? this.windowWidth : width;

      return {
        backgroundColor: this.canvasBgColor,
        minHeight: height ? height + "px" : "auto",
        width: width ? width + "px" : "auto",
        padding: this.canvasPadding ? this.canvasPadding + "px" : "0"
      };
    }
  },
  mounted() {
    this.$refs.newProjectDialog.openDialog();
  }
};
</script>

<style lang="scss">
.editor {
  //background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMElEQVQ4T2N89uzZfwY8QFJSEp80A+OoAcMiDP7//483HTx//hx/Ohg1gIFx6IcBALl+VXknOCvFAAAAAElFTkSuQmCC);
}

.nav-link[aria-expanded="true"] {
  color: #2c7be5 !important;
}

.navbar-light .navbar-nav .navbar-text a {
  color: #92a3ba;
}

@media (min-width: 1200px) {
  .main-content {
    margin-left: 300px !important;
  }
}

@media (max-width: 767px) {
  #nav_collapse {
    position: absolute;
    width: 100%;
    top: 53px;
    background-color: white;
    max-height: 80vh;
    overflow: auto;
    box-shadow: 0px 9px 10px #00000017;
  }
}

.nav-item .collapse,
.nav-item .collapsing {
  background-color: #f9fbfd;
  border-top: 1px solid #e3ebf6;
  border-bottom: 1px solid #e3ebf6;
}

.logo {
  @media (min-width: 1024px) {
    padding: 0 1rem 0.8rem 0;
    font-size: 2rem;
  }

  font-size: 1.5rem;
}
.CodeMirror {
  height: auto;
  box-shadow: none !important;
}

.CodeMirror-gutters {
  background-color: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
.navbar-vertical {
  .fa-fw {
    margin-right: 1rem;
  }
}

.custom-switch {
  right: -7px;
}

.editor-canvas {
  position: relative;
  display: inline-block;
  margin: 2rem;
  border: 3px dashed #e3ebf6;

  &:before {
    content: "CANVAS";
    top: -21px;
    left: -4px;
    position: absolute;
    font-size: 0.8rem;
    color: #b2b9c3;
  }
}

header {
  background-color: white;
  .header-body {
    padding: 1rem;
  }

  @media (max-width: 767px) {
    background-color: transparent;

    .header-body {
      border: 0;
      padding-bottom: 0;

      .header-title {
        margin-bottom: 0;
        font-weight: normal;
      }
    }
  }
}

.canvas-wrapper {
  overflow: auto;
}

.editor-wrapper {
  padding: 5rem;
}

.editor-window {
  padding: 14px;
}

.editor-window-titlebar {
  margin-bottom: 14px;
}

.editor-window--action {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;

  &.exit {
    background-color: #ff5f56;
    box-shadow: 0 0 1px #e0443e;
  }

  &.minimize {
    background-color: #ffbd2e;
    box-shadow: 0 0 1px #dea123;
  }

  &.maximize {
    background-color: #27c93f;
    box-shadow: 0 0 1px #1aab29;
  }

  &.win-mode {
    border-radius: 0;

    &.exit {
      background-color: #ff5f56;
      box-shadow: 0 0 1px #e0443e;
    }

    &.minimize {
      background-color: #ffbd2e;
      box-shadow: 0 0 1px #dea123;
    }

    &.maximize {
      background-color: #27c93f;
      box-shadow: 0 0 1px #1aab29;
    }
  }
}

.Windows-mode {
  flex-direction: row-reverse;

  .editor-window--title-input {
    text-indent: unset;
  }

  .editor-window--actions {
    .editor-window--action {
      border-radius: 0;
      height: auto;
      margin-right: 28px;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      &.exit {
        background-color: transparent;
        box-shadow: none;
        border-bottom: 2px solid #cfd2d1;
        width: 14px;
        top: -6px;
      }

      &.minimize {
        background-color: transparent;
        box-shadow: none;
        border: 2px solid #cfd2d1;
        width: 14px;
        height: 14px;
        top: 0px;
      }

      &.maximize {
        background-color: transparent;
        box-shadow: none;
        top: 2px;

        &:before {
          content: " ";
          display: inline-block;
          border-left: 2px solid #cfd2d1;
          height: 18px;
          transform: rotate(45deg);
          left: 2px;
          position: relative;
        }

        &:after {
          content: "";
          display: inline-block;
          border-right: 2px solid #cfd2d1;
          height: 18px;
          transform: rotate(-45deg);
        }
      }
    }
  }
}

.editor-window--title {
  text-align: center;
}

.editor-window--title-input {
  width: 100%;
  color: white;
  text-align: center;
  font-size: 14px;
  background: none;
  outline: none;
  border: none;
  text-indent: -60px;
}

.canvas-wrapper {
  height: calc(100vh - 80px);
}

.export-btn {
  .spinner-grow {
    width: 1rem;
    height: 1rem;
  }
}

iframe {
  border: none;
}

.download-preview {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 3rem;
  text-align: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMElEQVQ4T2N89uzZfwY8QFJSEp80A+OoAcMiDP7//483HTx//hx/Ohg1gIFx6IcBALl+VXknOCvFAAAAAElFTkSuQmCC);

  img {
    max-width: 100%;
  }
}


</style>
